class ExternalSearchSystemResponse {
    public Id: string;
    public Code: string;
    public Name: string;
}

export { ExternalSearchSystemResponse };
